var React = require('react');

function ButtonMenu (props) {
    return React.createElement("svg",props,[React.createElement("line",{"className":"line top","stroke":"#fff","x1":"0","y1":"10","x2":"15","y2":"10","key":0}),React.createElement("line",{"className":"line center","stroke":"#fff","x1":"0","y1":"5","x2":"15","y2":"5","key":1}),React.createElement("line",{"className":"line bottom","stroke":"#fff","x1":"0","y1":"0","x2":"15","y2":"0","key":2})]);
}

ButtonMenu.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 15 10","style":{"enableBackground":"new 0 0 15 10"}};

module.exports = ButtonMenu;

ButtonMenu.default = ButtonMenu;
